import axios from "axios";
// See https://stackoverflow.com/
// questions/40941118/axios-wont-send-cookie-ajax-xhrfields-does-just-fine

import config from "@/config";

// ///////////////////////////////////////////////////////////////////////////////////////
//
// Base api
//
// ///////////////////////////////////////////////////////////////////////////////////////
// Set default authorization headers for all requests if we have a sessionId
const sessionId = localStorage.getItem("session-id");
if (sessionId) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + sessionId;
}
const API_HOST = config.apiHostUrl;
const axiosOptions = {
  baseURL: (typeof API_HOST === "undefined" ? "http://localhost:8888" : API_HOST) + "/v1",
};
export const api = axios.create(axiosOptions);

// Log server error responses to help debug issues
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 400) {
      console.error(
        `API Error interceptor: ${error.response.status} ${error.config?.method?.toUpperCase()} ${error.config?.url}`,
        JSON.stringify(error.response.data)
      );
    }
    return Promise.reject(error);
  }
);
